<template>
  <DefaultLayout>
    <RouterView />
    <BaseToast />
    <VueQueryDevtools />
  </DefaultLayout>
</template>

<script setup lang="ts">
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import BaseToast from "@/components/base/BaseToast.vue";
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
import { useHead } from "@unhead/vue";

useHead({
  titleTemplate: (title?: string) => (!title ? "CareerSafe" : `${title} - CareerSafe`)
});
</script>

<style lang="scss">
@use "@/assets/scss/main";
</style>
